/**
 * Floating "TOP" control — visible while the footer is in view.
 * Desktop / mobile visibility from theme editor (data-show-desktop / data-show-mobile).
 */
(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  var footer = document.querySelector('[data-zaoud-footer]');
  var button = document.querySelector('[data-zaoud-footer-top]');
  if (!footer || !button) return;

  var showDesktop = button.getAttribute('data-show-desktop') === 'true';
  var showMobile = button.getAttribute('data-show-mobile') === 'true';
  var footerInView = false;

  function allowedOnViewport() {
    return DESKTOP_MQ.matches ? showDesktop : showMobile;
  }

  function setVisible(visible) {
    if (visible) {
      button.hidden = false;
      button.setAttribute('aria-hidden', 'false');
      button.removeAttribute('tabindex');
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
      button.setAttribute('aria-hidden', 'true');
      button.setAttribute('tabindex', '-1');
      button.hidden = true;
    }
  }

  function sync() {
    setVisible(allowedOnViewport() && footerInView);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          footerInView = entries[i].isIntersecting;
        }
        sync();
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );
    observer.observe(footer);
  }

  button.addEventListener('click', function (event) {
    event.preventDefault();
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var skip = document.querySelector('.skip-to-content-link, #MainContent');
    if (skip && typeof skip.focus === 'function') {
      try {
        skip.focus({ preventScroll: true });
      } catch (e) {
        skip.focus();
      }
    }
  });

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', sync);
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(sync);
  }

  sync();
})();
